module.exports = __webpack_public_path__ + "fonts/store_download_button_1.svg";